/* eslint-disable react/prop-types */
import * as React from 'react';

interface OutsideClickHandlerProps {
  onClickOutside: () => void;
  children: React.ReactNode;
}

export class OutsideClickHandler extends React.Component<OutsideClickHandlerProps> {
  private wrapperRef: HTMLDivElement;

  constructor(props) {
    super(props);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node: HTMLDivElement) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.onClickOutside();
    }
  }

  render() {
    return <div ref={this.setWrapperRef}>{this.props.children}</div>;
  }
}

export default OutsideClickHandler;
